const UserHomeData = {
    en: {
        seo: {
            title: 'Home | BH-Hardware',
            description: 'Your BH-Hardware home — shop professional garage door hardware, browse categories, and track your orders.'
        },
        hero: {
            greeting: 'Welcome back',
            subtitle: 'Your professional hardware hub. Browse the latest products or pick up where you left off.',
            shopBtn: 'Shop Now',
            ordersBtn: 'My Orders'
        },
        quickActions: {
            title: 'Quick Actions',
            shop: {
                label: 'Shop',
                description: 'Explore all products'
            },
            orders: {
                label: 'Orders',
                description: 'Track your history'
            },
            contact: {
                label: 'Get Support',
                description: 'We\'re here to help'
            }
        },
        products: {
            title: 'Featured Hardware',
            subtitle: 'Professional grade components for demanding applications.'
        },
        categories: {
            title: 'Shop by Category'
        },
        account: {
            title: 'Your Account',
            totalOrders: 'Orders',
            totalSpent: 'Spent',
            viewAll: 'View All Orders'
        }
    },
    he: {
        seo: {
            title: 'בית | BH-Hardware',
            description: 'מרכז הפרזול המקצועי שלך — עיין בציוד לדלתות מוסך, גלה קטגוריות ועקוב אחר ההזמנות שלך.'
        },
        hero: {
            greeting: 'ברוך שובך',
            subtitle: 'הבית המקצועי שלך לציוד פרזול. עיין במוצרים האחרונים או המשך מהיכן שעצרת.',
            shopBtn: 'לחנות',
            ordersBtn: 'ההזמנות שלי'
        },
        quickActions: {
            title: 'פעולות מהירות',
            shop: {
                label: 'לחנות',
                description: 'עיון בכל המוצרים'
            },
            orders: {
                label: 'ההזמנות שלי',
                description: 'מעקב אחר היסטוריה'
            },
            contact: {
                label: 'תמיכה',
                description: 'אנחנו כאן לעזור'
            }
        },
        products: {
            title: 'ציוד מומלץ',
            subtitle: 'רכיבים ברמה מקצועית לשימושים דורשניים.'
        },
        categories: {
            title: 'קנה לפי קטגוריה'
        },
        account: {
            title: 'החשבון שלך',
            totalOrders: 'הזמנות',
            totalSpent: 'שולם',
            viewAll: 'כל ההזמנות'
        }
    }
};

export function getUserHomeData(language) {
    return UserHomeData[language] || UserHomeData.en;
}

export default UserHomeData;
